import { Prescription } from '../types/models/Presc'

export const getUniquePrescriptions = (maybeDuplicatedList: Prescription[]) => {
  const uniqueList = [] as Prescription[]
  maybeDuplicatedList.forEach((item) => {
    const duplicatedItem = uniqueList.find(
      (uniqueItem) => uniqueItem.id === item.id
    )
    if (!duplicatedItem) {
      uniqueList.push(item)
    }
  })

  return uniqueList
}
